import React from 'react';

const Logo = ({ size = 'medium', showText = true, className = '', variant = 'default' }) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  const textSizeClasses = {
    small: 'text-lg',
    medium: 'text-xl',
    large: 'text-2xl',
    xl: 'text-3xl'
  };

  // Choisir le bon logo selon le variant
  const getLogoSrc = () => {
    if (variant === 'login') {
      return '/assets/logo-fopam.png';
    }
    return '/assets/logo-fopam-v2.png';
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo FOPAM */}
      <div className={`${sizeClasses[size]} relative`}>
        <img 
          src={getLogoSrc()}
          alt="Logo FOPAM"
          className="w-full h-full object-contain"
          onError={(e) => {
            // Fallback vers le SVG original si l'image ne charge pas
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        {/* SVG de fallback (caché par défaut) */}
        <svg viewBox="0 0 100 100" className="w-full h-full" style={{ display: 'none' }}>
          {/* Cercle extérieur */}
          <circle
            cx="50"
            cy="50"
            r="48"
            fill="none"
            stroke="#1e3a8a"
            strokeWidth="4"
          />
          
          {/* Silhouette humaine */}
          <path
            d="M35 45 Q35 35 50 35 Q65 35 65 45 L65 55 Q65 65 50 75 Q35 65 35 55 Z"
            fill="#f97316"
          />
          
          {/* Mains protectrices */}
          <path
            d="M25 40 Q20 35 25 30 Q30 35 35 40"
            fill="#1e3a8a"
          />
          <path
            d="M65 40 Q70 35 75 30 Q80 35 75 40"
            fill="#1e3a8a"
          />
          
          {/* Feuilles colorées */}
          <circle cx="30" cy="25" r="3" fill="#22c55e" />
          <circle cx="45" cy="20" r="3" fill="#3b82f6" />
          <circle cx="55" cy="20" r="3" fill="#f97316" />
          <circle cx="70" cy="25" r="3" fill="#22c55e" />
          <circle cx="40" cy="15" r="2" fill="#f97316" />
          <circle cx="60" cy="15" r="2" fill="#3b82f6" />
          <circle cx="25" cy="30" r="2" fill="#22c55e" />
          <circle cx="75" cy="30" r="2" fill="#f97316" />
        </svg>
      </div>
      
      {showText && (
        <span className={`font-bold text-primary-900 ${textSizeClasses[size]}`}>
          FOPAM+
        </span>
      )}
    </div>
  );
};

export default Logo;
